<template>
  <MasterDetail
    :hasFilter="false"
    :hasExportCSV="false"
    :hasExportXLSX="false"
    :canDelete="false"
    :opts="opts"
    :cols="cols"
    ref="masterDetail"
    :customResource="customResource">
  </MasterDetail>
</template>

<script>
import MasterDetail from '@/components/master-detail.vue';
import { mapGetters } from 'vuex';

export default {
    // props: {},
    components: {
        MasterDetail,
    },
    // mixins: [],
    // directives: {},
     data() {
         return {
           opts: {
           }
         }
     },
    computed: {
      ...mapGetters(['clientId']),
      projetoId() {
        return this.$route.params.id;
      },
      cols() {
        return [
          {
            key: 'id',
            hideInform: true,
            hideInTable: true,
          },
          {
            key: 'nome',
            name: 'Consultor',
            type: this.$fieldTypes.TEXT,
          },
          {
            key: 'telefone',
            name: 'Telefone',
            type: this.$fieldTypes.TELEPHONE,
          },
          {
            key: 'email',
            name: 'E-mail',
            type: this.$fieldTypes.TEXT,
          },
        ]
      },
      resourceUrl() {
        return this.apiResource(`/v1/captacao/responsaveis-finep`);
      },
      customResource() {
        const resource = this.resourceUrl;
        return {
          ...resource,
          get(...params) {
            return resource.get(...params).then((result) => {
              return result;
            })
          },
        }
      }
    },
    // filters: {},
    created() {
    },
    // mounted() {},
    // updated() {},
    // destroyed() {},
    methods: {
    },
    // watch: {},
}
</script>

<style>
</style>
